import { createContext, useState } from 'react';

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const [queryOptions, setQueryOptions] = useState({});
    const [fetchedTraders, setFetchedTraders] = useState();
    const [isF3Entered, setIsF3Entered] = useState(false);
    const [sdrFilter, setSdrFilter] = useState({
        allCurrencies: false,
        currencies: [],
        otherFilters: {
            irs: {
                tradesUnder1kDv01: true
            },
            fxOption: {
                tradesUnder2DExpiry: true,
                tradesUnder10MnNotional: true
            }
        }
    });
    const [userPreferences, setUserPreferences] = useState(null);
    const [equityCtaTicker, setEquityCtaTicker] = useState();
    const [eqCtaStats, setEqCtaStats] = useState({});
    const [ratesHighlights, setRatesHighlights] = useState([]);
    const [activeRatesCcy, setActiveRatesCcy] = useState();

    return <DataContext.Provider
        value={
            {
                queryOptions,
                setQueryOptions,
                fetchedTraders,
                setFetchedTraders,
                isF3Entered,
                setIsF3Entered,
                sdrFilter,
                setSdrFilter,
                userPreferences,
                setUserPreferences,
                equityCtaTicker,
                setEquityCtaTicker,
                eqCtaStats,
                setEqCtaStats,
                ratesHighlights,
                setRatesHighlights,
                activeRatesCcy,
                setActiveRatesCcy
            }}
    >
        {children}
    </DataContext.Provider>;
};
